import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/AppTypes";
import {
    IVRMWarehouseSearch,
    IVRMShelvesBatchInsert,
    IVRMWarehouseDetail,
    IVRMWarehouseInsert,
    IVRMWarehouseUpdate,
    IVRMAreaSearchFields,
    IVRMAreaDetail,
    IVRMAreaInsert,
    IVRMAreaBatchInsert,
    IVRMAreaUpdate,
    IVRMShelvesSearch,
    IVRMShelvesDetail,
    IVRMShelvesInsert,
    IVRMShelvesUpdate,
    IVRMshelfSearch,
    IVRMshelfDetail,
    IVRMshelfInsert,
    IVRMshelfBatchInsert,
    IVRMShelfUpdate,
    IVRMsearchTe,
    IVRMsearchTeDetail
} from "./warehouseTypes";


class WarehouseService {
    //仓库
    async page(searchVo: IVRMWarehouseSearch) {
        const apiUrl = "/assets/base/warehouse/findPage";
        return await httpRequest.post<IPage<IVRMWarehouseDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/assets/base/warehouse/findById/${id}`;
        return await httpRequest.get<IVRMWarehouseDetail>(apiUrl);
    }
    async insert(insertVo: IVRMWarehouseInsert) {
        const apiUrl = "/assets/base/warehouse/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: IVRMWarehouseUpdate) {
        const apiUrl = "/assets/base/warehouse/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }

    async getMaterialShelfTemporary(searchTe: IVRMsearchTe){
        const apiUrl = "/assets/purchase/getMaterialShelfTemporary";
        return await httpRequest.post<IVRMsearchTeDetail>(apiUrl, searchTe);
    }

    async areaPage(searchVo: IVRMAreaSearchFields) {
        const apiUrl = "/assets/base/warehouse/area/listPage";
        return await httpRequest.post<IPage<IVRMAreaDetail>>(apiUrl, searchVo);
    }
    async areaInsert(insertVo: IVRMAreaInsert) {
        const apiUrl = "/assets/base/warehouse/area/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    //批量录入区域
    async areaBatchInsert(insertVo: IVRMAreaBatchInsert) {
        const apiUrl = "/assets/base/warehouse/area/batchinsert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async areaUpdate(updateVo: IVRMAreaUpdate) {
        const apiUrl = "/assets/base/warehouse/area/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //区域导入
    async areaImport(file: { file: File }) {
        const appPageUrl = "/assets/base/warehouse/area/import";
        return await httpRequest.post<boolean>(appPageUrl, file);
    }
    //区域模板下载
    async areaDownloadTpl() {
        const appPageUrl = "/assets/base/warehouse/area/downloadTpl";
        return await httpRequest.getFile<boolean>(appPageUrl);
    }


    async shelvesPage(searchVo: IVRMShelvesSearch) {
        const apiUrl = "/assets/base/warehouse/shelves/listPage";
        return await httpRequest.post<IPage<IVRMShelvesDetail>>(apiUrl, searchVo);
    }
    async shelvesInsert(insertVo: IVRMShelvesInsert) {
        const apiUrl = "/assets/base/warehouse/shelves/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    //批量录入货架
    async shelvesBatchInsert(insertVo: IVRMShelvesBatchInsert) {
        const apiUrl = "/assets/base/warehouse/shelves/batchinsert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async shelvesUpdate(updateVo: IVRMShelvesUpdate) {
        const apiUrl = "/assets/base/warehouse/shelves/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //货架导入
    async shelvesImport(file: { file: File }) {
        const appPageUrl = "/assets/base/warehouse/shelves/import";
        return await httpRequest.post<boolean>(appPageUrl, file);
    }
    //货架模板下载
    async shelvesDownloadTpl() {
        const appPageUrl = "/assets/base/warehouse/shelves/downloadTpl";
        return await httpRequest.getFile<boolean>(appPageUrl);
    }


    async shelfPage(searchVo: IVRMshelfSearch) {
        const apiUrl = "/assets/base/warehouse/shelf/findPage";
        return await httpRequest.post<IPage<IVRMshelfDetail>>(apiUrl, searchVo);
    }
    async shelfAllPage(searchVo: IVRMshelfSearch) {
        const apiUrl = "/assets/base/warehouse/shelf/allPage";
        return await httpRequest.post<IVRMshelfDetail[]>(apiUrl, searchVo);
    }
    async shelfInsert(insertVo: IVRMshelfInsert) {
        const apiUrl = "/assets/base/warehouse/shelf/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    //批量新增货位
    async shelfBatchInsert(insertVo: IVRMshelfBatchInsert) {
        const apiUrl = "/assets/base/warehouse/shelf/batchinsert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async shelfUpdate(updateVo: IVRMShelfUpdate) {
        const apiUrl = "/assets/base/warehouse/shelf/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //货位导入
    async shelfImport(file: { file: File }) {
        const appPageUrl = "/assets/base/warehouse/shelf/import";
        return await httpRequest.post<boolean>(appPageUrl, file);
    }
    //货位模板下载
    async shelfDownloadTpl() {
        const appPageUrl = "/assets/base/warehouse/shelf/downloadTpl";
        return await httpRequest.getFile<boolean>(appPageUrl);
    }
    async exportWarehouse(searchVo: IVRMshelfSearch) {
        const apiUrl = "/assets/base/warehouse/shelf/export";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: 300000 });
    }
    //启用禁用账户
    async enable(param: any) {
        const apiUrl = "/assets/base/warehouse/shelf/change";
        return httpRequest
            .post<boolean>(apiUrl, param)
    }
}

export const warehouseService = new WarehouseService();
